var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "ul",
              { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
              [
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c("router-link", { attrs: { to: { name: "home" } } }, [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _c("i", { staticClass: "m-nav__link-icon la la-home" })
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n                      >\n                  ")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n                              " +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("authorizations_administration")
                          )
                        ) +
                        "\n                          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n                      >\n                  ")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n                          " +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("authorizations")
                          )
                        ) +
                        "\n                      "
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-content", attrs: { id: "message-container" } },
        [
          _c(
            "div",
            {
              staticClass:
                "m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-brand alert-dismissible fade show",
              attrs: { role: "alert" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "m-alert__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("veracity_message")
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "m-content", attrs: { id: "content" } }, [
        !_vm.edit
          ? _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
              _c("div", { staticClass: "m-portlet__head" }, [
                _c("div", { staticClass: "m-portlet__head-caption" }, [
                  _c("div", { staticClass: "m-portlet__head-title" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("h3", { staticClass: "m-portlet__head-text" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("registers")
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "m-portlet__body",
                  attrs: { id: "group-register" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-group m-form__group row container-register"
                    },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { "has-danger": _vm.errors.has("authorized_type") },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "authorized_type" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("authorized_type")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.authorized_type_id,
                                  expression: "authorized_type_id"
                                }
                              ],
                              class: {
                                "form-control": true,
                                error: _vm.errors.has("identification_type")
                              },
                              attrs: {
                                name: "authorized_type",
                                id: "authorized_type"
                              },
                              on: {
                                blur: function($event) {
                                  return _vm.pushAuthorization(
                                    _vm.num_authorized
                                  )
                                },
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.authorized_type_id = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.retreiveDocAutType(
                                      _vm.idx_car,
                                      _vm.authorized_type_id
                                    )
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.authorized_types, function(auth_type) {
                              return _c(
                                "option",
                                {
                                  key: auth_type.id,
                                  domProps: { value: auth_type.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(auth_type.name) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("authorized_type"),
                                  expression: "errors.has('authorized_type')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("authorized_type")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.is_reception
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              class: [
                                {
                                  "has-danger": _vm.errors.has(
                                    "department_auth"
                                  )
                                },
                                _vm.access_profile_id === "-1"
                                  ? "col-lg-4"
                                  : "col-lg-4"
                              ]
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "department_auth" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("department")
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("s-select2", {
                                attrs: {
                                  name: "department_auth",
                                  id: "department_auth",
                                  data: _vm.department_options
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.getDepDataSelect(
                                      $event,
                                      "select_visited"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.department_id,
                                  callback: function($$v) {
                                    _vm.department_id = $$v
                                  },
                                  expression: "department_id"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("department_auth"),
                                      expression:
                                        "errors.has('department_auth')"
                                    }
                                  ],
                                  staticClass: "m-form__help m--font-danger"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("department_auth")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.hideDepartment && _vm.department_id !== "",
                              expression:
                                "hideDepartment && department_id !== ''"
                            }
                          ],
                          class: [
                            { "has-danger": _vm.errors.has("access_profile") },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "access_profile" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("access_profile")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.access_profile_id,
                                  expression: "access_profile_id"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "form-control": true,
                                error: _vm.errors.has("identification_type")
                              },
                              attrs: {
                                name: "access_profile",
                                id: "access_profile"
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.access_profile_id = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.changeAccesProfile(
                                      _vm.access_profile_id
                                    )
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")("select_an_option")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.access_profiles, function(
                                access_profile
                              ) {
                                return _c(
                                  "option",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.authorized_type_id ===
                                            access_profile.authorized_type_id &&
                                          !_vm.accessProfile(
                                            access_profile.name
                                          ) &&
                                          _vm.department_id.toString() ===
                                            access_profile.department_id.toString(),
                                        expression:
                                          "authorized_type_id === access_profile.authorized_type_id && !accessProfile(access_profile.name) && department_id.toString() === access_profile.department_id.toString()"
                                      }
                                    ],
                                    key: access_profile.id,
                                    domProps: { value: access_profile.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(access_profile.name) +
                                        "\n                "
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.num_authorized == 1,
                                      expression: "num_authorized==1"
                                    }
                                  ],
                                  attrs: { value: "-1" }
                                },
                                [_vm._v(_vm._s(_vm._f("capitalize")("custom")))]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("access_profile"),
                                  expression: "errors.has('access_profile')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("access_profile")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.hide_ap_container &&
                                _vm.access_profile_id !== "" &&
                                  _vm.access_profile_id !== "-1",
                              expression:
                                "hide_ap_container && (access_profile_id !== '' && access_profile_id !== '-1')"
                            }
                          ],
                          class: [
                            {
                              "has-danger": _vm.errors.has("see_access_profile")
                            },
                            "col-lg-1"
                          ]
                        },
                        [
                          _c(
                            "label",
                            { attrs: { for: "see_access_profile" } },
                            [_vm._v(" ")]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-success m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill",
                              attrs: {
                                href: "#",
                                "data-toggle": "modal",
                                "data-backdrop": "static",
                                "data-keyboard": "false",
                                "data-target": "#access_profile_modal"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.infoModal.apply(null, arguments)
                                }
                              }
                            },
                            [_c("i", { staticClass: "la la-eye" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.access_profile_id === "-1" &&
                                  _vm.group_register === true) ||
                                (_vm.group_register && !_vm.hideDepartment),
                              expression:
                                "(access_profile_id === '-1' && group_register === true) || (group_register && !hideDepartment)"
                            }
                          ],
                          staticClass: "col-lg-3 element-register"
                        },
                        [
                          !_vm.is_reception
                            ? _c("label", [_vm._v(" ")])
                            : _vm._e(),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-success m-btn m-btn--icon m-btn--wide",
                              attrs: {
                                href: "#",
                                "data-toggle": "modal",
                                "data-backdrop": "static",
                                "data-keyboard": "false",
                                "data-target": "#access_profile_modal"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showAccessProfileModal.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "la la-calendar" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("capitalize")("access_data"))
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.num_authorized > 1 &&
                                  _vm.department_id != "") ||
                                (_vm.num_authorized > 1 && !_vm.hideDepartment),
                              expression:
                                "(num_authorized > 1 && department_id != '') || (num_authorized > 1 && !hideDepartment)"
                            }
                          ],
                          staticClass:
                            "form-control checks col-lg-3 element-register"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "m-checkbox-inline checks-align" },
                            [
                              _c("label", { staticClass: "m-checkbox" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group_register,
                                      expression: "group_register"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.group_register)
                                      ? _vm._i(_vm.group_register, null) > -1
                                      : _vm.group_register
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.group_register,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.group_register = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.group_register = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.group_register = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(
                                          "share_auth_data_question"
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                ),
                                _c("span")
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.group_register &&
                                _vm.num_authorized > 1 &&
                                _vm.authorized_type_id === 1 &&
                                _vm.department_id != "",
                              expression:
                                "group_register && num_authorized > 1 && authorized_type_id === 1 && department_id != ''"
                            }
                          ],
                          class: [
                            _vm.department_id !== "-1"
                              ? "col-lg-2"
                              : "col-lg-3",
                            "element-register"
                          ]
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "m-checkbox-inline checks-align" },
                            [
                              _c("label", { staticClass: "m-checkbox" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("capitalize")("undefined_date")
                                    ) +
                                    "\n                  "
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.is_undefined,
                                      expression: "is_undefined"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    name: "undefined"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.is_undefined)
                                      ? _vm._i(_vm.is_undefined, null) > -1
                                      : _vm.is_undefined
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.is_undefined,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.is_undefined = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.is_undefined = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.is_undefined = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span")
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.group_register &&
                                _vm.num_authorized > 1 &&
                                (_vm.department_id != "" || _vm.is_reception),
                              expression:
                                "group_register && num_authorized > 1 && (department_id != '' || is_reception)"
                            }
                          ],
                          class: [
                            { "has-danger": _vm.errors.has("start_date") },
                            "col-lg-3 element-register"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "start_date" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("start_date")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("s-date-time-picker", {
                            attrs: {
                              id: "start_date",
                              name: "start_date",
                              options: _vm.config.start,
                              placeholder: "AAAA-MM-DD"
                            },
                            on: {
                              empty: function($event) {
                                _vm.group.start_date = $event
                              },
                              input: function($event) {
                                return _vm.startDate(_vm.group.start_date)
                              }
                            },
                            model: {
                              value: _vm.group.start_date,
                              callback: function($$v) {
                                _vm.$set(_vm.group, "start_date", $$v)
                              },
                              expression: "group.start_date"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("start_date"),
                                  expression: "errors.has(`start_date`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("start_date")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.group_register &&
                                _vm.num_authorized > 1 &&
                                (_vm.department_id != "" || _vm.is_reception) &&
                                !_vm.is_undefined,
                              expression:
                                "group_register && num_authorized > 1 && (department_id != '' || is_reception) && !is_undefined"
                            }
                          ],
                          class: [
                            { "has-danger": _vm.errors.has("end_date") },
                            "col-lg-3 element-register"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "end_date" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("end_date")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("s-date-time-picker", {
                            attrs: {
                              id: "end_date",
                              name: "end_date",
                              options: _vm.config.end,
                              placeholder: "AAAA-MM-DD"
                            },
                            on: {
                              empty: function($event) {
                                _vm.group.end_date = $event
                              }
                            },
                            model: {
                              value: _vm.group.end_date,
                              callback: function($$v) {
                                _vm.$set(_vm.group, "end_date", $$v)
                              },
                              expression: "group.end_date"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("end_date"),
                                  expression: "errors.has(`end_date`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.errors.first("end_date")) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.complete && _vm.hideVisitor
                    ? _c("div", { staticClass: "form-group m-form__group" }, [
                        _c(
                          "div",
                          { staticClass: "m-content select-container" },
                          [
                            _c("s-select2", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                name: "select_visited",
                                id: "select_visited",
                                placeholder: "select_visited",
                                data: _vm.select2_array,
                                clear_select: _vm.clear_select,
                                minimumInput: 3
                              },
                              on: {
                                input: function($event) {
                                  return _vm.getDataSelect(
                                    $event,
                                    "select_visited"
                                  )
                                }
                              },
                              model: {
                                value: _vm.visited_to,
                                callback: function($$v) {
                                  _vm.visited_to = $$v
                                },
                                expression: "visited_to"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-outline-danger m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x clean-select",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.clearSelect()
                                  }
                                }
                              },
                              [_c("i", { staticClass: "la la-trash" })]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("select_visited"),
                                    expression: "errors.has(`select_visited`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.errors.first("select_visited")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          { staticClass: "m-form m-form--state" },
          [
            (_vm.authorization.length > 1 && _vm.hideDepartment) ||
            (_vm.authorization.length > 1 && !_vm.hideDepartment)
              ? _c(
                  "div",
                  { staticClass: "m-portlet__body" },
                  [
                    _vm.department_id != "" || !_vm.hideDepartment
                      ? _c(
                          "form-wizard",
                          {
                            attrs: {
                              title: "",
                              subtitle: "",
                              color: "#232C4B",
                              errorColor: "#D73925",
                              "start-index": _vm.tab_validator
                            },
                            on: {
                              "on-complete": _vm.validateForm,
                              "update:startIndex": function($event) {
                                _vm.tab_validator = $event
                              },
                              "update:start-index": function($event) {
                                _vm.tab_validator = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "footer",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "wizard-footer-left" },
                                        [
                                          props.activeTabIndex > 0
                                            ? _c(
                                                "wizard-button",
                                                {
                                                  style: props.fillButtonStyle,
                                                  nativeOn: {
                                                    click: function($event) {
                                                      return props.prevTab()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("capitalize")(
                                                        _vm._f("translate")(
                                                          "back"
                                                        )
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "wizard-footer-right" },
                                        [
                                          _c(
                                            "wizard-button",
                                            {
                                              staticClass:
                                                "wizard-footer-right",
                                              style: props.fillButtonStyle,
                                              nativeOn: {
                                                click: function($event) {
                                                  props.isLastStep
                                                    ? _vm.validate()
                                                    : props.nextTab()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("capitalize")(
                                                    _vm._f("translate")(
                                                      props.isLastStep
                                                        ? "done"
                                                        : "next"
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4170069492
                            )
                          },
                          _vm._l(_vm.authorization, function(auto, key) {
                            return _c(
                              "tab-content",
                              {
                                key: key,
                                attrs: {
                                  title: _vm.title + " " + (key + 1),
                                  icon: "fa fa-user",
                                  "before-change": _vm.validateForm
                                }
                              },
                              [
                                _c("s-form-content", {
                                  attrs: {
                                    is_reception: _vm.is_reception,
                                    auto: auto,
                                    idx: key,
                                    is_undefined: _vm.is_undefined,
                                    group_register: _vm.group_register,
                                    identification_types:
                                      _vm.identification_types,
                                    edit: _vm.edit,
                                    profiles: _vm.profiles,
                                    tab_validator: _vm.tab_validator,
                                    access_profile_id: _vm.access_profile_id,
                                    num_authorized: _vm.num_authorized,
                                    authorized_types: _vm.authorized_types,
                                    authorized_type_id: _vm.authorized_type_id,
                                    department_type_id: _vm.department_id,
                                    hide_department: _vm.hideDepartment,
                                    visited_to: _vm.visited_to,
                                    access_credentials: _vm.access_credentials,
                                    isTraining: _vm.isTraining,
                                    range_time: _vm.range_time
                                  },
                                  on: {
                                    validate: function($event) {
                                      _vm.tab_validator = $event
                                    },
                                    showAccessDayModalChild:
                                      _vm.showAccessDayModalChild
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : (_vm.authorization.length > 0 && _vm.hideDepartment) ||
                (_vm.authorization.length > 0 && !_vm.hideDepartment)
              ? _vm._l(_vm.authorization, function(auto, key) {
                  return _c(
                    "div",
                    { key: key },
                    [
                      _vm.complete &&
                      (_vm.department_id != "" ||
                        !_vm.hideDepartment ||
                        _vm.is_reception)
                        ? _c("s-form-content", {
                            attrs: {
                              is_reception: _vm.is_reception,
                              auto: auto,
                              idx: key,
                              is_undefined: _vm.is_undefined,
                              group_register: _vm.group_register,
                              identification_types: _vm.identification_types,
                              edit: _vm.edit,
                              profiles: _vm.profiles,
                              tab_validator: _vm.tab_validator,
                              access_profile_id: _vm.access_profile_id,
                              authorized_types: _vm.authorized_types,
                              authorized_type_id: _vm.authorized_type_id,
                              num_authorized: _vm.num_authorized,
                              department_type_id: _vm.department_id,
                              document_reception: _vm.$route.params.document,
                              hide_department: _vm.hideDepartment,
                              visited_to: _vm.visited_to,
                              is_cargo: _vm.is_cargo,
                              access_credentials: _vm.access_credentials,
                              isTraining: _vm.isTraining,
                              range_time: _vm.range_time
                            },
                            on: {
                              showAccessDayModalChild:
                                _vm.showAccessDayModalChild
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.complete &&
            ((_vm.department_id !== "" && _vm.num_authorized < 2) ||
              (!_vm.hideDepartment && _vm.num_authorized < 2) ||
              (_vm.num_authorized < 2 && _vm.is_reception))
              ? _c("div", { staticClass: "actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.validate()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm.edit ? "Editar" : "save")
                        )
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "access_profile_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("create_access_profile")
            )
          }
        },
        [
          this.openone
            ? _c("s-access-profile", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_access_day,
                    expression: "!modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  data: _vm.access_profile_view,
                  same_dates: _vm.same_dates,
                  create_outside: _vm.create_access_days,
                  create_outside_group: true,
                  access_profile_responsible: _vm.access_profile_responsible,
                  view: _vm.create_access_days ? false : true,
                  edit_outside: false,
                  show_department: false
                },
                slot: "body"
              })
            : _vm._e(),
          _vm._v(" "),
          this.openone
            ? _c("s-access-day", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_access_day,
                    expression: "modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  open_outside: true,
                  data: _vm.access_day_view,
                  view: _vm.create_access_days ? false : true,
                  create_outside: _vm.create_access_days,
                  modal: true,
                  array_in_auth: true,
                  edit_outside: false
                },
                slot: "body"
              })
            : _vm._e(),
          _vm._v(" "),
          !this.openone
            ? _c("s-access-profile", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_access_day,
                    expression: "!modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  data: _vm.access_profile_view,
                  same_dates: _vm.same_dates,
                  auto: _vm.authorization[_vm.tab_validator],
                  create_outside: true,
                  create_outside_group: false,
                  view: false,
                  id_authType: "auth_form_wizard",
                  id_department: "department_form_wizard",
                  id_cancel: "btn-cancel-form-wizard",
                  id_control_point: "control_points",
                  access_profile_responsible: _vm.access_profile_responsible,
                  show_department: false
                },
                slot: "body"
              })
            : _vm._e(),
          _vm._v(" "),
          !this.openone
            ? _c("s-access-day", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_access_day,
                    expression: "modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  open_outside: true,
                  data: _vm.authorization[_vm.tab_validator],
                  view: false,
                  create_outside: true,
                  array_in_auth: true,
                  modal: true
                },
                slot: "body"
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_cars_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("vehicles")),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "true",
                    "data-scrollable": "true",
                    "data-max-height": "200"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group m-form__group" },
                    _vm._l(_vm.authorization[_vm.idx_car].own_cars, function(
                      car,
                      idx
                    ) {
                      return _c(
                        "div",
                        {
                          key: idx,
                          staticClass: "row space-down card-container"
                        },
                        [
                          _c("div", { staticClass: "col-lg-9" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  { "has-danger": _vm.errors.has("plate") },
                                  "space-row-container"
                                ]
                              },
                              [
                                _c("label", { attrs: { for: "plate" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("plate")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: car.license_plate,
                                      expression: "car.license_plate"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|alpha_num|min:6|max:10",
                                      expression:
                                        "'required|alpha_num|min:6|max:10'"
                                    }
                                  ],
                                  staticClass: "form-control m-input",
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: {
                                    type: "text",
                                    id: "plate",
                                    name: "plate",
                                    placeholder: _vm._f("capitalize")(
                                      _vm._f("translate")("enter_plate")
                                    )
                                  },
                                  domProps: { value: car.license_plate },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        car,
                                        "license_plate",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("plate"),
                                        expression: "errors.has(`plate`)"
                                      }
                                    ],
                                    staticClass: "m-form__help m--font-danger"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.translateErrorMessage(
                                            "plate",
                                            _vm.errors.first("plate")
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-3" }, [
                            _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.dropCar(idx)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.addCar.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("close"))
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.is_cargo
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_cargo_cars_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")("vehicle_cargo")
                ),
                close_header: true
              }
            },
            [
              _c("section", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "form-group m-form__group row" }, [
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has(
                              "vehicle_type_id" + _vm.idx_car
                            )
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "vehicle_type_id" + _vm.idx_car } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("vehicle_type")
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .vehicle_type_id,
                                expression:
                                  "authorization[idx_car].cargo_cars.vehicle_type_id"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-control": true,
                              error: _vm.errors.has(
                                "vehicle_type_id" + _vm.idx_car
                              )
                            },
                            attrs: {
                              "data-vv-as": _vm._f("translate")("vehicle_type"),
                              name: "vehicle_type_id" + _vm.idx_car,
                              id: "vehicle_type_id" + _vm.idx_car
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "vehicle_type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.cargo_vehicles(
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .vehicle_type_id,
                                    _vm.idx_car
                                  )
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")("select_an_option"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.cargo_vehicle_type, function(
                              cargo_vehicle,
                              idx
                            ) {
                              return _c(
                                "option",
                                {
                                  key: idx,
                                  domProps: { value: cargo_vehicle.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("capitalize")(cargo_vehicle.name)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has(
                                  "vehicle_type_id" + _vm.idx_car
                                ),
                                expression:
                                  "errors.has(`vehicle_type_id${idx_car}`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "vehicle_type",
                                    _vm.errors.first(
                                      "vehicle_type_id" + _vm.idx_car
                                    )
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "cargo_type_vehicle_type" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "cargo_type_vehicle_type" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("vehicle_type")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.authorization[_vm.idx_car].cargo_cars
                                        .cargo_vehicle_type,
                                    expression:
                                      "authorization[idx_car].cargo_cars.cargo_vehicle_type"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                class: {
                                  "form-control": true,
                                  error: _vm.errors.has(
                                    "cargo_type_vehicle_type" + _vm.idx_car
                                  )
                                },
                                attrs: {
                                  "data-vv-as": _vm._f("translate")(
                                    "vehicle_type"
                                  ),
                                  name: "cargo_type_vehicle_type" + _vm.idx_car,
                                  id: "cargo_type_vehicle_type" + _vm.idx_car
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.authorization[_vm.idx_car].cargo_cars,
                                      "cargo_vehicle_type",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")("select_an_option")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.cargo_type_vehicles, function(
                                  cargo_vehicle,
                                  idx
                                ) {
                                  return _vm.hideCargoType(
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .vehicle_type_id,
                                    cargo_vehicle.type
                                  )
                                    ? _c(
                                        "option",
                                        {
                                          key: idx,
                                          domProps: {
                                            value: cargo_vehicle.name
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  cargo_vehicle.name
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_type_vehicle_type" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`cargo_type_vehicle_type${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "vehicle_type",
                                        _vm.errors.first(
                                          "cargo_type_vehicle_type" +
                                            _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "truck_license_plate" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "truck_license_plate" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("truck_license_plate")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .truck_license_plate,
                                  expression:
                                    "authorization[idx_car].cargo_cars.truck_license_plate"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "truck_license_plate"
                                ),
                                name: "truck_license_plate" + _vm.idx_car,
                                id: "truck_license_plate" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .truck_license_plate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "truck_license_plate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "truck_license_plate" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`truck_license_plate${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "truck_license_plate",
                                        _vm.errors.first(
                                          "truck_license_plate" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "cargo_order" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              { attrs: { for: "cargo_order" + _vm.idx_car } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("cargo_order")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .cargo_order,
                                  expression:
                                    "authorization[idx_car].cargo_cars.cargo_order"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "cargo_order"
                                ),
                                name: "cargo_order" + _vm.idx_car,
                                id: "cargo_order" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .cargo_order
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "cargo_order",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_order" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`cargo_order${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_order",
                                        _vm.errors.first(
                                          "cargo_order" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.is_articulate
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "trailer_license_plate" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "trailer_license_plate" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")(
                                        "trailer_license_plate"
                                      )
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .trailer_license_plate,
                                  expression:
                                    "authorization[idx_car].cargo_cars.trailer_license_plate"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|alpha",
                                  expression: "'required|alpha'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "trailer_license_plate"
                                ),
                                name: "trailer_license_plate" + _vm.idx_car,
                                id: "trailer_license_plate" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .trailer_license_plate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "trailer_license_plate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "trailer_license_plate" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`trailer_license_plate${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "trailer_license_plate",
                                        _vm.errors.first(
                                          "trailer_license_plate" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "container_number" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: { for: "container_number" + _vm.idx_car }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("container_number")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .container_number,
                                  expression:
                                    "authorization[idx_car].cargo_cars.container_number"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "numeric",
                                  expression: "'numeric'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "container_number"
                                ),
                                name: "container_number" + _vm.idx_car,
                                id: "container_number"
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .container_number
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "container_number",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "container_number" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`container_number${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "container_number",
                                        _vm.errors.first(
                                          "container_number" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "cargo_vehicle_brand" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "cargo_vehicle_brand" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("cargo_vehicle_brand")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .cargo_vehicle_brand,
                                  expression:
                                    "authorization[idx_car].cargo_cars.cargo_vehicle_brand"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "alpha|min:5|max:20",
                                  expression: "'alpha|min:5|max:20'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "cargo_vehicle_brand"
                                ),
                                name: "cargo_vehicle_brand" + _vm.idx_car,
                                id: "cargo_vehicle_brand" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .cargo_vehicle_brand
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "cargo_vehicle_brand",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_vehicle_brand" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`cargo_vehicle_brand${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_vehicle_brand",
                                        _vm.errors.first(
                                          "cargo_vehicle_brand" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "cargo_vehicle_color" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "cargo_vehicle_color" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("cargo_vehicle_color")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .cargo_vehicle_color,
                                  expression:
                                    "authorization[idx_car].cargo_cars.cargo_vehicle_color"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "alpha|min:4|max:20",
                                  expression: "'alpha|min:4|max:20'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "cargo_vehicle_color"
                                ),
                                name: "cargo_vehicle_color" + _vm.idx_car,
                                id: "cargo_vehicle_color" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .cargo_vehicle_color
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "cargo_vehicle_color",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_vehicle_color" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`cargo_vehicle_color${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_vehicle_color",
                                        _vm.errors.first(
                                          "cargo_vehicle_color" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "cargo_vehicle_model" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "cargo_vehicle_model" + _vm.idx_car
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("cargo_vehicle_model")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .cargo_vehicle_model,
                                  expression:
                                    "authorization[idx_car].cargo_cars.cargo_vehicle_model"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "min:4|max:20",
                                  expression: "'min:4|max:20'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "cargo_vehicle_model"
                                ),
                                name: "cargo_vehicle_model" + _vm.idx_car,
                                id: "cargo_vehicle_model" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .cargo_vehicle_model
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "cargo_vehicle_model",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_vehicle_model" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`cargo_vehicle_model${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_vehicle_model",
                                        _vm.errors.first(
                                          "cargo_vehicle_model" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.authorization[_vm.idx_car].cargo_cars
                      .vehicle_type_id !== ""
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "carrier_company" + _vm.idx_car
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: { for: "carrier_company" + _vm.idx_car }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("carrier_company")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.authorization[_vm.idx_car].cargo_cars
                                      .carrier_company,
                                  expression:
                                    "authorization[idx_car].cargo_cars.carrier_company"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "min:5|max:20",
                                  expression: "'min:5|max:20'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": _vm._f("translate")(
                                  "carrier_company"
                                ),
                                name: "carrier_company" + _vm.idx_car,
                                id: "carrier_company" + _vm.idx_car
                              },
                              domProps: {
                                value:
                                  _vm.authorization[_vm.idx_car].cargo_cars
                                    .carrier_company
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.authorization[_vm.idx_car].cargo_cars,
                                    "carrier_company",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "carrier_company" + _vm.idx_car
                                    ),
                                    expression:
                                      "errors.has(`carrier_company${idx_car}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "carrier_company",
                                        _vm.errors.first(
                                          "carrier_company" + _vm.idx_car
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("a", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    attrs: {
                      id: "close_cargo_vehicle_modal",
                      "data-dismiss": "modal"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.clearForm(_vm.idx_car)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("capitalize")("clear")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", id: "add_cargo_cars_modal" },
                      on: { click: _vm.validateCargoVechicles }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("capitalize")("save")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_credentials_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("credentials")),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "true",
                    "data-scrollable": "true",
                    "data-max-height": "220"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group m-form__group" },
                    _vm._l(
                      _vm.authorization[_vm.idx_car].authorized_credentials,
                      function(auto_credential, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            class: [
                              { "space-margin-top": idx > 0 },
                              "row card-container"
                            ]
                          },
                          [
                            _c("div", { staticClass: "col-lg-9" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    {
                                      "has-danger": _vm.errors.has(
                                        "credential_" + _vm.idx_car + "_" + idx
                                      )
                                    },
                                    "space-row-container"
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          "credential_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("credential")
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: auto_credential.credential_id,
                                          expression:
                                            "auto_credential.credential_id"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value:
                                            "validateAccessCredential:" +
                                            _vm.idx_car +
                                            "," +
                                            idx,
                                          expression:
                                            "`validateAccessCredential:${idx_car},${idx}`"
                                        }
                                      ],
                                      class: [
                                        "form-control",
                                        {
                                          error: _vm.errors.has(
                                            "credential_" +
                                              _vm.idx_car +
                                              "_" +
                                              idx
                                          )
                                        }
                                      ],
                                      attrs: {
                                        id:
                                          "credential_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx,
                                        name:
                                          "credential_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            auto_credential,
                                            "credential_id",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("capitalize")(
                                                _vm._f("translate")(
                                                  "select_an_option"
                                                )
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.access_credentials, function(
                                        c
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: c.id,
                                            domProps: { value: c.id }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(c.name) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "credential_" +
                                              _vm.idx_car +
                                              "_" +
                                              idx
                                          ),
                                          expression:
                                            "errors.has(`credential_${idx_car}_${idx}`)"
                                        }
                                      ],
                                      staticClass: "m-form__help m--font-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.translateErrorMessage(
                                              "credential",
                                              _vm.errors.first(
                                                "credential_" +
                                                  _vm.idx_car +
                                                  "_" +
                                                  idx
                                              )
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    {
                                      "has-danger": _vm.errors.has(
                                        "value_credential_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx
                                      )
                                    },
                                    "space-down"
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          "value_credential_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")(
                                              "value_credential"
                                            )
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: auto_credential.value,
                                        expression: "auto_credential.value"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|numeric|max:15",
                                        expression: "'required|numeric|max:15'"
                                      }
                                    ],
                                    staticClass: "form-control m-input",
                                    attrs: {
                                      type: "text",
                                      id:
                                        "value_credential_" +
                                        _vm.idx_car +
                                        "_" +
                                        idx,
                                      "data-vv-as": "credential",
                                      name:
                                        "value_credential_" +
                                        _vm.idx_car +
                                        "_" +
                                        idx,
                                      placeholder: _vm._f("capitalize")(
                                        _vm._f("translate")(
                                          "enter_value_credential"
                                        )
                                      ),
                                      readonly:
                                        parseInt(
                                          auto_credential.credential_id
                                        ) === 0
                                          ? true
                                          : false
                                    },
                                    domProps: { value: auto_credential.value },
                                    on: {
                                      keyup: function($event) {
                                        return _vm.uniqueCredential(
                                          auto_credential.value,
                                          auto_credential.credential_id,
                                          _vm.idx_car
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          auto_credential,
                                          "value",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "value_credential_" +
                                              _vm.idx_car +
                                              "_" +
                                              idx
                                          ),
                                          expression:
                                            "errors.has(`value_credential_${idx_car}_${idx}`)"
                                        }
                                      ],
                                      staticClass: "m-form__help m--font-danger"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.translateErrorMessage(
                                              "value_credential",
                                              _vm.errors.first(
                                                "value_credential_" +
                                                  _vm.idx_car +
                                                  "_" +
                                                  idx
                                              )
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-lg-3" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(" ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.dropCredential(idx)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ]
                        )
                      }
                    ),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.addCredential.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("close"))
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.authorization[_vm.tab_validator].undefined_date
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_expiration_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("expirations")),
                close_header: true,
                size: "modal-sm modal-dialog-centered"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "220"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(
                          _vm.authorization[_vm.tab_validator].doc_types,
                          function(docs, k) {
                            return _vm.show_expirations
                              ? _c(
                                  "div",
                                  {
                                    key: k,
                                    staticClass:
                                      "row doc_expiration space-row-container"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-12",
                                        class: {
                                          "has-danger": _vm.errors.has(
                                            "expires_doc_" +
                                              _vm.tab_validator +
                                              "_" +
                                              k
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for:
                                                "expires_doc_" +
                                                _vm.tab_validator +
                                                "_" +
                                                k
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    docs.document.name
                                                  )
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.expirationDate(
                                                _vm.authorization[
                                                  _vm.tab_validator
                                                ].doc_types
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                        _c("s-date-time-picker", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                docs.required === 1
                                                  ? "required"
                                                  : "",
                                              expression:
                                                "docs.required === 1 ? 'required' : ''"
                                            }
                                          ],
                                          attrs: {
                                            options: _vm.config_expiration,
                                            "data-vv-as": docs.document.name,
                                            name:
                                              "expires_doc_" +
                                              _vm.tab_validator +
                                              "_" +
                                              k,
                                            id:
                                              "expires_doc_" +
                                              _vm.tab_validator +
                                              "_" +
                                              k,
                                            alias: docs.document.name,
                                            placeholder: "DD-MM-YYYY",
                                            readonly: ""
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.docExpiration(
                                                docs.id,
                                                _vm.tab_validator,
                                                k,
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.authorization[
                                                _vm.tab_validator
                                              ].doc_auth_types[k].value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.authorization[
                                                  _vm.tab_validator
                                                ].doc_auth_types[k],
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "authorization[tab_validator].doc_auth_types[k].value"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "expires_doc_" +
                                                    _vm.tab_validator +
                                                    "_" +
                                                    k
                                                ),
                                                expression:
                                                  "errors.has(`expires_doc_${tab_validator}_${k}`)"
                                              }
                                            ],
                                            staticClass:
                                              "m-form__help m--font-danger"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "expires_doc_" +
                                                      _vm.tab_validator +
                                                      "_" +
                                                      k
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.closeForm }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("close"))
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.group_register && _vm.access_profile_id === "-1") ||
      !_vm.hideDepartment
        ? _c("s-modal", {
            attrs: {
              id: "access_profile_modal_auth",
              title: _vm._f("capitalize")(
                _vm._f("translate")("create_access_profile")
              )
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "flaticon-exclamation-1" }),
      _vm._v(" "),
      _c("span")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__close" }, [
      _c("button", {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61a680ff", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a680ff","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/authorization/condominium/New.vue
// module id = 614
// module chunks = 0 1 9